import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AdminProvider } from './context/AdminContext';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductGrid from './components/ProductGrid';
import About from './components/About';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ProductPage from './pages/ProductPage';
import Shop from './pages/Shop';
import AdminPage from './pages/AdminPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import Receipt from './pages/Receipt';
import PaymentStatus from './pages/PaymentStatus';
import ProcessingPayment from './pages/ProcessingPayment';

function Home() {
  return (
    <>
      <Hero />
      <ProductGrid />
      <About />
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when route changes
    // Use multiple methods to ensure compatibility across all browsers
    window.scrollTo(0, 0);
    // Also ensure document element scrolls to top (for some browsers)
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

function Layout() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isReceiptPage = location.pathname.startsWith('/receipt');

  return (
    <div className="App">
      {!isAdminPage && !isReceiptPage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:productId" element={<ProductPage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/processing-payment" element={<ProcessingPayment />} />
        <Route path="/receipt/:orderId" element={<Receipt />} />
        <Route path="/receipt" element={<Receipt />} />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          } 
        />
      </Routes>
      {!isAdminPage && !isReceiptPage && <Footer />}
      {!isAdminPage && !isReceiptPage && <WhatsAppButton />}
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <AdminProvider>
        <Router>
          <ScrollToTop />
          <Layout />
        </Router>
      </AdminProvider>
    </CartProvider>
  );
}

export default App;
